import { Observable, switchMap } from 'rxjs';
import { JwtAuthHeaders } from '../models/jwt-auth-headers';
import { retryWhenJwtAuthError } from './retry-when-jwt-auth-error';

/**
 * TODO!: ASAP, move all fetch calls into Data Access and remove this from `public-api.ts`.
 *
 */
export function withJwt(
  fetch: (jwtAuthHeaders: JwtAuthHeaders) => Observable<Response>
) {
  return new Observable<JwtAuthHeaders>((subscriber) => {
    subscriber.next(new JwtAuthHeaders());
    subscriber.complete();
  }).pipe(switchMap(fetch), retryWhenJwtAuthError());
}
